import { render, staticRenderFns } from "./index.page.vue?vue&type=template&id=2ed6a088&"
import script from "./index.page.vue?vue&type=script&lang=js&"
export * from "./index.page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\mzkj\\要炼\\yl-pc-business\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2ed6a088')) {
      api.createRecord('2ed6a088', component.options)
    } else {
      api.reload('2ed6a088', component.options)
    }
    module.hot.accept("./index.page.vue?vue&type=template&id=2ed6a088&", function () {
      api.rerender('2ed6a088', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/finance/returnBond/index.page.vue"
export default component.exports